<script>
import Layout from '@layouts/main';
import ServiceProviderForm from '@views/serviceProviders/form';

export default {
  components: {
    Layout,
    ServiceProviderForm,
  },
  page() {
    return {
      title: this.$t('titles.create_service_provider'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.service_providers'),
          to: { name: 'serviceProviders.index' },
        },
        {
          text: this.$t('titles.create_service_provider'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create() {
      this.$router.push({
        name: 'serviceProviders.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_service_provider')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <ServiceProviderForm @submitted="create" />
    </b-card>
  </Layout>
</template>
